// extracted by mini-css-extract-plugin
export var allowed = "productTile-module--allowed--g7BnL";
export var checkMark = "productTile-module--checkMark--1smtI";
export var checkMarkContainer = "productTile-module--checkMarkContainer--8wSju";
export var icon = "productTile-module--icon--ePJ8M";
export var info = "productTile-module--info--pB4aU";
export var label = "productTile-module--label--pdOav";
export var name = "productTile-module--name--k0iUI";
export var notAllowed = "productTile-module--notAllowed--RVXD2";
export var tile = "productTile-module--tile--4+T7r";